
import React, { Component } from 'react';
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import { BASE } from '../api/api'
import Axios from 'axios'
import './login.css'


class LoginModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            pwd: '',
            email: '',
            cpwd: '',
            phone: '',
            login_state: true

        }
    }

    submit() {
        if (this.state.login_state == true && this.state.name.length > 0 && this.state.pwd.length > 0) {

            this.login(this.state.name, this.state.pwd)
        }
        else if (this.state.login_state == false) {
            if (this.state.name.length > 2) {
                if (this.state.pwd === this.state.cpwd) {
                    let term = this.state.phone;
                    let re = new RegExp("^[0-9]*$");
                    let ere = new RegExp("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}")
                    if (ere.test(this.state.email) == true) {
                        if (re.test(term) == true) {
                            let formbody = {
                                "name": [{ "value": this.state.name }],
                                "mail": [{ "value": this.state.email }],
                                "pass": [{ "value": this.state.pwd }],
                                "field_phone_number": [{ "value": this.state.phone }]
                            }
                            Axios({
                                url: BASE+"user/register?_format=json",
                                method: "POST",
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                data: formbody
                            })
                                .then((data) => {
                                    this.login(this.state.name, this.state.pwd)
                                })
                                .catch((err) => {
                                    console.log(err)
                                    let error = err.response.data.message;
                                    let ind = error.indexOf("failed");
                                    if (ind > 0) {
                                        alert(error.substring(ind + 7))
                                    }
                                    else
                                        alert(error)
                                });

                        }
                        else {
                            alert("Enter a valid phone number")
                        }
                    }
                    else {
                        alert("Enter a valid email id")
                    }
                }
                else {
                    alert("Passwords donot match")
                }
            }
            else {
                alert("Username must be minimum 3 charecters long")
            }

        }
    }
    login(name, pwd) {
        let details = {
            grant_type: "password",
            client_id: "ab15755c-47f7-4699-b306-75f6a58c00b7",
            client_secret: "default",
            username: name,
            password: pwd
        }
        let url = window.location.href;
        let url_string = url;
        let urlStr = new URL(url_string);
        let c = urlStr.searchParams.get("redirect");
        let type = urlStr.searchParams.get("type");
        let key = urlStr.searchParams.get("key");
        let filter = urlStr.searchParams.get("filter");
        console.log(filter,"filter")
        let formBody = [];
        for (let property in details) {
            let encodedKey = encodeURIComponent(property);
            let encodedValue = encodeURIComponent(details[property]);
            formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");
        Axios({
            url: BASE+"oauth/token",
            method: "POST",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: formBody
        })
            .then((data) => {
                if (data.data.access_token) {
                    Axios({
                        url: BASE+"jsonapi/user/user/?filter[name][condition][path]=name&filter[name][condition][value]=" + name,
                        method: "GET",
                        headers: {
                            'Authorization': "Bearer " + data.data.access_token
                        },
                    })
                        .then((da) => {
                            if (da.data.data.length > 0) {
                                localStorage.setItem('token', data.data.access_token)
                                localStorage.setItem("uid", da.data.data[0].id)
                                // if(c && (!type ||type == null))
                                // this.props.history.push(c);
                                // else if(c && (type && type != null))
                                // this.props.history.push(c+'/?type='+type);
                                // else if(key)
                                // window.location.href=c+"?key="+ key +"&filter="+filter;
                                // else
                                // this.props.history.push('/');
                                this.props.isLoginTrue(true)
                            }
                            else{
                                alert("Something went wrong, Please try again")
                                // this.props.isLoginTrue(false)
                            }
                        })
                }

            })
            .catch((err) => {
                alert("Username and password donot match")
            })
    }

    render() {

        return (
            <div className='formrea loginpagem modallogin'>
                <div className="listing bgwhite" style={{ width: '100%', margin: '0 auto' }}>


                    <div className="page-title">
                        <div className="title-wrapper">
                            <div className="container">
                                <h1 className="heading">{this.state.login_state == true ? "Login" : "Sign Up"}</h1>
                            </div>
                        </div>
                    </div>

                    <div className="main-content" style={{minHeight:0}}>
                        <div className="container">
                            <div className="row">
                                <div className="region region-content">
                                    <form className="webform-client-form webform-client-form-275" id="webform-client-form-275" accept-charset="UTF-8">
                                        <div>
                                            <div className="form-component" >
                                                <label for="edit-submitted-name">Username <span className="form-required" title="This field is required.">*</span></label>
                                                <input id="name" name="name" type="text" value={this.state.name}
                                                    onChange={(e) => this.setState({ name: e.target.value })} />
                                            </div>
                                            <div className="form-component" style={{ display: this.state.login_state == false ? '' : 'none' }}>
                                                <label for="edit-submitted-email">Email <span className="form-required" title="This field is required.">*</span></label>
                                                <input id="email" name="email" type="text" value={this.state.email}
                                                    onChange={(e) => this.setState({ email: e.target.value })} />
                                            </div>
                                            <div className="form-component" style={{ display: this.state.login_state == false ? '' : 'none' }}>
                                                <label for="edit-submitted-phone">Phone Number <span className="form-required" title="This field is required.">*</span></label>
                                                <input id="phone" name="phone" type="text" value={this.state.phone}
                                                    onChange={(e) => this.setState({ phone: e.target.value })} />
                                            </div>
                                            <div className="form-component" >
                                                <label for="edit-submitted-pwd">Password <span className="form-required" title="This field is required.">*</span></label>
                                                <input id="pwd" name="pwd" type="password" value={this.state.pwd}
                                                    onChange={(e) => this.setState({ pwd: e.target.value })} />
                                            </div>
                                            <div className="form-component" style={{ display: this.state.login_state == false ? '' : 'none' }}>
                                                <label for="edit-submitted-cpwd"> Confirm Password <span className="form-required" title="This field is required.">*</span></label>
                                                <input id="cpwd" name="cpwd" type="password" value={this.state.cpwd}
                                                    onChange={(e) => this.setState({ cpwd: e.target.value })} />
                                            </div>
                                            <div className="cf">
                                                <button className="login_submit" onClick={() => this.submit()} type="button">Submit</button>
                                            </div>

                                            <div className="anchor_lnks">
                                                <a style={{ display: this.state.login_state == true ? '' : 'none' }} onClick={() => this.setState({
                                                    login_state: false, name: '',
                                                    pwd: '',
                                                    email: '',
                                                    cpwd: '',
                                                    phone: '',
                                                })}>Create a new account</a>
                                                <a style={{ display: this.state.login_state == false ? '' : 'none' }} onClick={() => this.setState({
                                                    login_state: true, name: '',
                                                    pwd: '',
                                                    email: '',
                                                    cpwd: '',
                                                    phone: '',
                                                })}>Already a user? Login</a>
                                                <div style={{ display: this.state.login_state == true ? '' : 'none' }} className='div_gap'>|</div>
                                                <a style={{ display: this.state.login_state == true ? '' : 'none' }} onClick={() => (this.setState({
                                                    name: '',
                                                    pwd: '',
                                                    email: '',
                                                    cpwd: '',
                                                    phone: '',
                                                }), this.props.history.push('/password'))}>Forgot Password</a>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        )


    }

}

export default LoginModal;